export const PolicySourceEpic = 1;
export const PolicySourceManual = 2;
export const PolicySourceAOR = 3;
export const PolicySourceControlling = 4;
export const PolicySourceParticipant = 5;
export const PolicySourceMultiCarrierSchedules = 6;
// Policies created from a scanned binder. Carries the same permissions as a manual
// upload and is external for filtering; the separate source records how it got here.
export const PolicySourceAIUpload = 7;

// Represents types in the PolicySource table
export const PolicySource = {
  PolicySourceEpic,
  PolicySourceManual,
  PolicySourceAOR,
  PolicySourceControlling,
  PolicySourceParticipant,
  PolicySourceMultiCarrierSchedules,
  PolicySourceAIUpload,
} as const;

export type PolicySourceType = typeof PolicySource[keyof typeof PolicySource];
